import React, {useState, useEffect} from 'react'
import back from '../back.svg'
import './newChat.css'

const NewChat = (props) => {
    const [msg,
        setMsg] = useState('');
    const [uEmail,
        setUEmail] = useState('');
    const chatExists = async() => {
        const docKey = buildDocKey();
        const chat = await props
            .firebase
            .db
            .collection('chats')
            .doc(docKey)
            .get();
        return chat.exists;
    }
    const userExist = () => {
        return props
            .firebase
            .userExist();
    }

    const submitNewChat = async(e) => {
        e.preventDefault();
        const userExistn = await userExist();
        if (userExistn) {
            const chatExisto = await chatExists();
            chatExisto
                ? goToChat()
                : createChat();
        }
    }
    const createChat = () => {
        props.newChatSubmitFn({sendTo: uEmail, message: msg});
    }
    const goToChat = () => props.goToChatFn(buildDocKey(), msg);
    const buildDocKey = () => {
        return [props.firebase.auth.currentUser.email, uEmail]
            .sort()
            .join(':');
    }
    const goBack =()=>{
        props.setNewChat(false);
    }
    return (
        <div id="createChat">
            <div id="backDiv">
                <img onClick={goBack} src={back}/>
            </div>
            <div id="form">
                <h2>Create New Chat</h2>
                <br/>
                <div className="input-field col s12">
                    <input
                        onChange={e => setUEmail(e.target.value)}
                        id="email"
                        type="email"
                        className="validate"
                        required
                        autoFocus/>
                    <label htmlFor="email">Enter Your Email</label>
                </div>
                <div className="input-field col s12">
                    <input
                        onChange={e => setMsg(e.target.value)}
                        id="message"
                        type="text"
                        className="validate"
                        required/>
                    <label htmlFor="message">Enter Your Message</label>
                </div>
                <button onClick={submitNewChat} className="cusButton">Send</button>
            </div>
        </div>
    )
}

export default NewChat;